import * as yup from 'yup';

import { createOtpCodeSchema } from 'core/components/form';

export const otpVerifySchema = yup
  .object({
    code: createOtpCodeSchema(),
  })
  .required();

export type OtpVerifyFormData = yup.InferType<typeof otpVerifySchema>;
